import { createStyles, makeStyles, Theme } from '@material-ui/core';

export default makeStyles((theme: Theme) =>
  createStyles({
    companyName: {
      fontSize: '20px',
    },
    buttonWrapper: {
      width: '40px',
      height: '40px',
      padding: 12,
      minWidth: 'max-content !important',
      borderRadius: 12,
      '& .MuiButton-startIcon': {
        marginRight: 0,
        marginLeft: 0,
      },
    },
    controlBlock: {
      backgroundColor: theme.palette.background.paper,
      margin: '-24px',
      padding: '16px 48px',
      marginLeft: '-40px',
      marginRight: '-40px',
    },
    teamDetailsBlock: {
      backgroundColor: theme.palette.background.paper,
      padding: '24px 48px 16px',
      marginLeft: '-40px',
      marginRight: '-40px',
      borderTop: `1px solid ${theme.palette.divider}`,
    },
    linkedLocationsHeader: {
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      gap: 16,
      marginBottom: 8,
    },
    linkedLocationsTitle: {
      fontSize: 15,
      fontWeight: 600,
      color: theme.palette.text.primary,
      letterSpacing: 0.25,
      lineHeight: '22px',
    },
    assignLocationButton: {
      backgroundColor: theme.palette.background.paper,
      borderRadius: 8,
      padding: '9px 16px',
      color: theme.palette.primary.main,
      fontSize: 13,
      fontWeight: 600,
      textTransform: 'none',
      gap: 12,
    },
    locationCard: {
      borderRadius: 8,
      border: `1px solid ${theme.palette.divider}`,
      padding: '8px 8px 8px 16px',
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      marginBottom: 8,
    },
    locationCardLabel: {
      fontSize: 13,
      fontWeight: 500,
      letterSpacing: 0.25,
      lineHeight: '22px',
      width: 130,
      flexShrink: 0,
    },
    locationCardName: {
      fontSize: 13,
      fontWeight: 500,
      lineHeight: '22px',
    },
    locationCardAddress: {
      fontSize: 13,
      fontWeight: 400,
      lineHeight: '22px',
    },
    locationCardMapButton: {
      width: 40,
      height: 40,
      minWidth: 40,
      borderRadius: 8,
      padding: 0,
      marginLeft: 16,
    },
  })
);
